export default function InitAccordion() {
    const accordionToggles = document.querySelectorAll('.accordion-toggle');

    accordionToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            
            const target = document.querySelector(this.dataset.accordionTarget);
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            
            // Close all other accordions
            accordionToggles.forEach(otherToggle => {
                if (otherToggle !== this) {
                    const otherTarget = document.querySelector(otherToggle.dataset.accordionTarget);
                    otherToggle.setAttribute('aria-expanded', 'false');
                    otherTarget.classList.remove('expanding');
                }
            });
            
            // Toggle current accordion
            if (isExpanded) {
                this.setAttribute('aria-expanded', 'false');
                target.classList.remove('expanding');
            } else {
                this.setAttribute('aria-expanded', 'true');
                target.classList.add('expanding');
            }
        });
    });
}